import { render } from "./Christmas.vue?vue&type=template&id=6b5c75cb"
const script = {}
script.render = render

export default script